// Duits (de), dailyApp: zelfde vorm als dailyApp.nl.ts (WP4 dagelijkse schermen).
export const appDailyDe = {
    stars: {
        tab: 'Sterne',
        approvals: 'Freigeben',
        approvalsEmpty: 'Nichts freizugeben.',
        handled: 'Erledigt',
        rewards: 'Belohnungen',
        savingFor: 'Spart für {goal}',
        noGoal: 'Noch kein Sparziel',
        goalLabel: 'Sparziel von {name}',
        adjustLabel: 'Punkte anpassen für {name}',
        history: 'Letzte Punkte von {name}',
        info: 'Kinder verdienen Sterne mit Aufgaben. Hier siehst du pro Kind, was es ausgeben kann, wofür es spart und was noch freigegeben werden muss. Eine Belohnung fügst du unter Belohnungen hinzu oder änderst sie dort.',
    },
    agenda: {
        title: 'Kalender',
        rides: 'Fahrten',
        tools: 'Mehr für den Kalender',
        toolsTitle: 'Kalender',
        calendars: 'Kalender verbinden',
        calendarsHint: 'Termine aus Google, Outlook oder iCloud hier zeigen.',
        exportHint: 'Alle Termine als Kalenderdatei (.ics).',
        trashHint: 'Gelöschte Termine 30 Tage lang wiederherstellen.',
    },
    pinboard: {
        title: 'Pinnwand',
        label: 'Teile der Pinnwand',
        notes: 'Notizen',
        messages: 'Nachrichten',
        wishes: 'Wünsche',
    },
    kids: {
        title: 'Kinder',
        label: 'Bereiche für die Kinder',
        learning: 'Lernziele',
        growth: 'Wachstum',
        school: 'Schule',
        filter: 'Kind wählen',
        all: 'Alle Kinder',
    },
    chores: {
        label: 'Art der Aufgaben',
        series: 'Feste Aufgaben',
        chores: 'Hausarbeiten',
    },
    recipes: {
        more: 'Mehr laden',
        shown: '{shown} von {total}',
        pick: 'Wähle ein Rezept aus der Liste.',
        filter: 'Welche Rezepte',
    },
    menu: {
        past: {
            one: '{count} Tag früher in dieser Woche',
            other: '{count} Tage früher in dieser Woche',
        },
        showPast: 'Zeigen',
        hidePast: 'Ausblenden',
        suggestions: 'Vorschläge',
        suggestionsCount: 'Vorschläge ({count})',
        shelfHint: 'Zieh ein Rezept auf einen Tag.',
    },
};
//# sourceMappingURL=dailyApp.de.js.map